import { Components, Theme } from '@mui/material';

export const MuiTable: Components<Theme>['MuiTable'] = {
  defaultProps: {
    size: 'small',
  },
};
